import React, { useEffect, useState } from "react";
import Table from "../ui/Table";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { SortIcon } from "../utils/Icons";
import { bm_date, drawPOSStatus, drawPrice, getRowClass, istl } from "../utils/Utils";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from "dayjs";
import Space from "../ui/Space";
import Cookies from "js-cookie";
import Card from "../ui/Card";
import Label from "../ui/Label";
import Divider from "../ui/Divider";
import { render } from "@testing-library/react";
import Button from "../ui/Button";
import { get_initial } from "../controllers/OrdersController";

export default function OrdersList(props) {

    const {
        controller = "",
        signal = {},
        loading = false,
        setLoading = () => { },
        data = [],
        setData = () => { },
        selected = {},
        setSelected = () => { },
        route = "",
        align = "start",
        setAlign = () => { },
        view = true,
        filters = {},
        setFilters = () => { },
        row_key = "order_id",
        isSearchMode = false
    } = props;


    const buffer = 20;
    const columns = [
        { key: "order_number", title: <>Order</>, width: 80, align: "left" },
        { key: "status", title: <>Stat</>, width: 60, align: "left" },
        { key: "req_date", title: <>Date</>, width: 95, align: "left", render: (e) => <span style={{"fontFamily" : "var(--font-mono)"}}>{bm_date(e)}</span> },
        { key: "supplier", title: <>Supl</>, width: 80, align: "left" },
        { key: "quantity", title: <>Qty</>, width: 60, align: "right" },
        { key: "invoice_price", title: <>Price</>, width: 90, align: "right", render: (e) => drawPrice(e, true) },
        { key: "supplier", title: <>Supl</>, width: 80, align: "left" },
        { key: "title", title: <>Title</>, width: 180, grow: true, align: "left" },
        {
            key: "customer", title: <>Customer</>, width: 80, grow: true, align: "left", render: (e) => {
                return (e?.name) ? e.name : ""
            }
        },
        { key: "po_number", title: <>PO</>, width: 120, align: "left" },
        { key: "invoice", title: <>Inv#</>, width: 120, align: "left" },
    ];


    const getCurrentIndex = () => {
        const index = data.findIndex(item => item?.[row_key] === selected?.[row_key]);
        return index >= 0 ? index : 0;
    };

    // const next = (_rows = 1) => {
    //     if (data.length === 0) {
    //         setSelected({});
    //         return;
    //     }

    //     const currentIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]);

    //     if (currentIndex < 0) return;

    //     const nextIndex = currentIndex + _rows;
    //     const nextItem = data[nextIndex];

    //     // Prefetch near the bottom
    //     if (nextIndex >= data.length - buffer && !loading) {
    //         fetchNext();
    //     }

    //     // Only move selection if the row exists
    //     if (!nextItem) {
    //         return;
    //     }

    //     setAlign("auto");
    //     setSelected(nextItem);
    // };

    // const prev = (_rows = 1) => {
    //     if (data.length === 0) {
    //         setSelected({});
    //         return;
    //     }

    //     const currentIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]);

    //     if (currentIndex < 0) return;

    //     const prevIndex = currentIndex - _rows;
    //     const prevItem = data[prevIndex];

    //     // Prefetch near the top
    //     if (prevIndex <= buffer && !loading) {
    //         setAlign("start")
    //         fetchPrev();
    //         return; 
    //     }

    //     // Only move selection if the row exists
    //     if (!prevItem) {
    //         return;
    //     }

    //     setAlign("auto");
    //     setSelected(prevItem);
    // };

    // const fetchNext = () => {
    //     if (loading) return;

    //     setLoading(true);

    //     pubCall("order.getNext", { ...filters, [row_key]: data[data.length - 1]?.[row_key] }, (_s, _r) => {
    //         if (_s) {
    //             const rows = Array.isArray(_r) ? _r : [];

    //             if (rows.length > 0) {
    //                 setData(prev => prev.concat(rows));
    //             }
    //         } else {
    //             showError(_r);
    //         }

    //         setLoading(false);
    //     });
    // };


    // const fetchPrev = () => {
    //     if (loading) return;

    //     console.log("fetchPrev")

    //     setLoading(true);

    //     pubCall("order.getPrevious", { ...filters, [row_key]: data[0]?.[row_key] }, (_s, _r) => { if (_s) {
    //             const rows = Array.isArray(_r) ? _r : [];

    //             if (rows.length > 0) {
    //                 setData(prev => rows.concat(prev));
    //             }
    //         } else {
    //             showError(_r);
    //         }

    //         setLoading(false);
    //     });
    // };



    const fetchNext = () => {
        if (loading || isSearchMode) { return }
        setLoading(true);
        pubCall("order.getNext", { ...filters, [row_key]: data[data.length - 1]?.[row_key] }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }
    
    
    const fetchPrev = () => {
        if (loading || isSearchMode) { return }
        setLoading(true);
        pubCall("order.getPrevious", { ...filters, [row_key]: data[0]?.[row_key] }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r.concat([...data])]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }
    
    
    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");

        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        // Fetch chunk...

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };

    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;


        if (prevIndex < 1) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };

    const fetch = () => {
        if (loading) { return }
        setLoading(true);

        if (Cookies.get("selected_order")) {
            if(Cookies.get("selected_order") === "undefined") {
                Cookies.remove("selected_order");
                delete filters.order_id;
            } else {
                filters.order_id = Cookies.get("selected_order");
            }
        } else {
            delete filters.order_id;
        }

        get_initial({ ...filters }, (_s, _r) => {
            if (_s) {
                if (_r.rows_previous.length > 0) {
                    setAlign("start");
                }
                setData(_r.rows_previous.concat(_r.rows_next));
                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(fetch, [filters]);

    function findDuplicateKeys(arr, key) {
        const seen = new Set();
        const duplicates = new Set();

        arr.forEach(item => {
            const value = item?.[key];

            if (seen.has(value)) {
                duplicates.add(value);
            } else {
                seen.add(value);
            }
        });

        alert(JSON.stringify([...duplicates]))

    }

    return (
        <div style={{ "display": (view) ? "block" : "none", "padding": "0px 15px" }}>
            <Label style={{ "textAlign": "left" }}>&nbsp;Search Results:</Label>
            <div className="shim" />
            <Space grow size={10} style={{ "alignItems": "start" }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 600 }}>

                    {/* <Button onClick={() => findDuplicateKeys(data, "order_id")}>Are there any dupes? </Button> */}
                    <VirtualTable
                        controller={controller}
                        scrollbar={true}
                        scrollindicator={true}
                        infinite={true}
                        onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                        next={next}
                        prev={prev}
                        onLoadMore={(_start, _end, _prepend) => {
                            if (_prepend) {
                                if (data?.length > 0 && data[0]?.number !== 1) {
                                    fetchPrev()
                                }
                            } else {
                                if (data?.length > 0) {
                                    fetchNext();
                                }

                            }
                        }}
                        rowClass={(e) => {
                            const _cls = getRowClass(e);
                            if (!e?.order_id || !(e?.status.startsWith("R") || e?.status.startsWith("C"))) {
                                return _cls + " history-active"
                            }
                            return _cls;
                        }}

                        align={align}
                        row_key={row_key}
                        current={selected}
                        data={data}
                        columns={columns}
                        width={0}
                        loading={loading}
                        offset={459}
                        height={192}
                        route={route}
                    />
                </div>

            </Space>

        </div >
    )
}